<template>
	<div class="d-flex flex-column justify-center align-center w-100">
		<v-icon size="96" color="error">mdi-alert-circle-outline</v-icon>
		<h1 class="text-h2 my-4">404 - Page Not Found</h1>
		<p class="text-subtitle-1 mb-6">Sorry, the page you are looking for does not exist.</p>
		<v-btn color="primary" :to="__authPath">
			Go to Home
		</v-btn>
	</div>
</template>

<script>
import Main from "../../../../mixins/Main";

export default {
	name: 'NotFound',
	mixins: [Main]
}
</script>
